import { type ReactiveCookie, useIsAdminCookie } from '@/plugins/cookie-plugin'

export function useIsAdmin(): ReactiveCookie<boolean> {
    return useIsAdminCookie()
}
